import { render, staticRenderFns } from "./outstockDetailDialogGoods.vue?vue&type=template&id=fa986c48&scoped=true&"
import script from "./outstockDetailDialogGoods.vue?vue&type=script&lang=js&"
export * from "./outstockDetailDialogGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa986c48",
  null
  
)

export default component.exports